export interface ParsedUrl {
    path: string;
    fragment: string | null;
    isInternal: boolean;
    queryParams: { [key: string]: string };
}

export function parseUrl(url: string, customFragment?: string): ParsedUrl {
    const isInternal = url.startsWith('/');
    let path = url;
    let fragment: string | null = null;
    const queryParams: { [key: string]: string } = {};

    if (isInternal) {
        // Parse path
        path = url.split(/[#?]/)[0];

        if (customFragment) {
            fragment = customFragment;
        } else if (url.includes('#')) {
            // Parse fragment
            const fragmentPart = url.split('#')[1];
            fragment = fragmentPart ? fragmentPart.split('?')[0] : null;
        }

        // Parse query params
        if (url.includes('?')) {
            const queryString = url.split('?')[1]?.split('#')[0] || '';
            const urlParams = new URLSearchParams(queryString);
            urlParams.forEach((value, key) => {
                queryParams[key] = value;
            });
        }
    }

    return { path, fragment, queryParams, isInternal };
}
